import graphql__fb08c7f6b73eb46f8f24 from "./__generated__/MailingListViewQuery.graphql.ts";
import graphql__aa6d1e06555b5005c3f5 from "./__generated__/MailingListViewRenameMutation.graphql.ts";import * as React from "react";
import {useState, useCallback} from "react";
import {graphql, useMutation} from "react-relay";
import {Outlet} from "react-router";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import MailingListViewQuery, {MailingListViewQuery as MailingListViewQueryType} from "./__generated__/MailingListViewQuery.graphql";
import MarketingHeader from "./presentational/MarketingHeader";
import {useIntl} from "react-intl";

type MailingListViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type MailingListViewProps = MailingListViewParams & ConnectedProps<typeof connector>;

const MailingListView: React.FC<MailingListViewProps> = (props) => {
    const intl = useIntl();
    const [isSaving, setIsSaving] = useState(false);

    const {mailingList} = usePreloadedQuery<MailingListViewQueryType>(
        graphql__fb08c7f6b73eb46f8f24,
        props.prepared.mailingListViewQuery,
    );

    const [commitRenameMutation] = useMutation(graphql__aa6d1e06555b5005c3f5);

    const handleTitleEdit = useCallback((newTitle: string) => {
        if (!mailingList) return;
        setIsSaving(true);
        commitRenameMutation({
            variables: {
                input: {
                    id: mailingList.id,
                    name: newTitle,
                }
            },
            onCompleted: () => {
                setIsSaving(false);
            },
            onError: () => {
                setIsSaving(false);
            },
        });
    }, [mailingList, commitRenameMutation]);

    if (mailingList == null) {
        return <p>{intl.formatMessage({id: 'mailingList.notFound'})}</p>;
    }

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.marketing'}), to: '/marketing'},
        {label: intl.formatMessage({id: 'breadcrumb.mailingLists'}), to: '/marketing/lists'},
        {label: mailingList.name, to: '/marketing/lists/' + mailingList.id},
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <MarketingHeader
                type="mailingList"
                title={mailingList.name}
                identifier={mailingList.id}
                badge={mailingList.archivedAt ? {
                    value: 'ARCHIVED',
                    label: intl.formatMessage({id: 'mailingList.status.archived'}),
                    states: {gray: ['ARCHIVED']}
                } : undefined}
                onTitleEdit={handleTitleEdit}
                isSaving={isSaving}
            />
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={mailingList}/>
            </div>
        </>
    );
}

export default connector(MailingListView);

function prepare_MailingListView(params, relayEnvironment) {
    return {
        mailingListViewQuery: loadQuery(
            relayEnvironment,
            MailingListViewQuery,
            {
                id: params.id,
            },
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_MailingListView};
